var map = {
	"./Bluesy.mp3": "1bd5",
	"./Cartoon.mp3": "43d2",
	"./Cheer.mp3": "a5ca",
	"./Cold.mp3": "92ee",
	"./Cruise.mp3": "79d5",
	"./Danzon.mp3": "2304",
	"./Dizzy.mp3": "cad2",
	"./Doug.mp3": "64e8",
	"./Guitar.mp3": "ee00",
	"./Left.mp3": "cf46",
	"./Loping.mp3": "ce21",
	"./Mess.mp3": "53ce",
	"./Puppy.mp3": "f45f",
	"./Slay.mp3": "8cdd",
	"./Sour.mp3": "7fbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";